class EuroAnnouncement extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
    this.index = this.slides.findIndex((slide) => !slide.hasAttribute('hidden'));
    if (this.index < 0) this.index = 0;

    this.querySelector('[data-announcement-prev]')?.addEventListener('click', () => this.go(-1));
    this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.go(1));
  }

  go(delta) {
    if (this.slides.length === 0) return;

    this.slides[this.index].setAttribute('hidden', '');
    this.index = (this.index + delta + this.slides.length) % this.slides.length;
    this.slides[this.index].removeAttribute('hidden');
  }
}

customElements.define('euro-announcement', EuroAnnouncement);

class EuroHeaderDrawer extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-drawer-open]');
    this.backdrop = this.querySelector('[data-drawer-backdrop]');
    this.panel = this.querySelector('.euro-header__drawer-panel');
    this.toggles = Array.from(this.querySelectorAll('[data-drawer-toggle]'));

    if (!this.openButton || !this.backdrop) return;

    this.openButton.addEventListener('click', () => {
      if (this.classList.contains('is-open')) this.close();
      else this.open();
    });

    // Close: backdrop tap, close button, Escape.
    this.backdrop.addEventListener('click', () => this.close());
    this.querySelectorAll('[data-drawer-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };

    // Accordion: each parent row toggles its own sub-list, siblings collapse.
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        this.toggle(toggle);
      });
    });

    // Close the drawer when a plain navigation link is chosen.
    this.panel?.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (link) this.close();
    });
  }

  toggle(button) {
    const item = button.closest('li');
    if (!item) return;
    const willOpen = !item.classList.contains('is-open');

    // Collapse sibling sub-lists at the same nesting level first.
    item.parentElement?.querySelectorAll(':scope > li.is-open').forEach((openItem) => {
      if (openItem !== item) this.setItem(openItem, false);
    });

    this.setItem(item, willOpen);
    button.setAttribute('aria-expanded', String(willOpen));
  }

  setItem(item, open) {
    item.classList.toggle('is-open', open);
    const button = item.querySelector(':scope > [data-drawer-toggle]');
    if (button) button.setAttribute('aria-expanded', String(open));
  }

  open() {
    if (this.classList.contains('is-open')) return;
    this.classList.add('is-open');
    this.openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.onKeydown);
  }

  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    this.openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('euro-header-drawer', EuroHeaderDrawer);
